import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.reducer';
import {
  selectAreFiltersAvailable,
  selectRoomFilters,
} from '@store/hotel-availability/hotel-availability.selectors';
import { Observable } from 'rxjs';
import { RoomFilter } from '@core/models/room-filter/room-filter';
import { RoomFiltersComponent } from '../../room-filters/room-filters.component';
import { NgIf, AsyncPipe } from '@angular/common';
@Component({
    selector: 'am-filters-container',
    templateUrl: './filters-container.component.html',
    styleUrls: ['./filters-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        RoomFiltersComponent,
        AsyncPipe,
    ],
})
export class FiltersContainerComponent {
  public filters$: Observable<RoomFilter[]>;
  public areFiltersAvailable$: Observable<boolean>;

  constructor(private readonly store: Store<AppState>) {
    this.filters$ = this.store.select(selectRoomFilters);
    this.areFiltersAvailable$ = this.store.select(selectAreFiltersAvailable);
  }
}
